module.exports = (state, _message) => {
  state.isSearching = false
}
